var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callGraphQL } from '../../common/common';
import { deleteResource as deleteResourceMutation } from '../../../graphql/mutations';
import { deleteS3Object, getSignedUrl, UploadType } from '../../S3Service';
import Axios from 'axios';
import { getExtension } from '../../User/src/UserMutations';
export function store(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield getSignedUrl(file.name, file.type, UploadType.PUBLIC_RESOURCE);
        yield Axios.put(response.payload.signedUrl, file, {
            headers: {
                'Content-Type': file.type
            }
        });
        return response.payload.key.replace('public/', '');
    });
}
function deleteDBResource(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return callGraphQL(deleteResourceMutation, { input: { id } }).then((res) => { var _a; return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.deleteResource; });
    });
}
/**
 * Deletes a resource by its id and key (resourcePath)
 * @param id
 * @param key
 */
export function deleteResourceById(id, key) {
    return __awaiter(this, void 0, void 0, function* () {
        const extension = getExtension(key);
        yield deleteS3Object(key, extension, UploadType.PUBLIC_RESOURCE);
        yield deleteDBResource(id);
    });
}
